import { PodV2PendingPage } from '@/widgets/pod-v2/ui/pod-v2-pending-page';
import { PodV2Page } from '@/widgets/pod-v2';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const podV2SearchSchema = z.object({
    publishGrpId: z.number().optional(),
    publishId: z.number().optional(),
    returnTo: z.string().optional(),
});

export const Route = createFileRoute('/sets/pod-v2/')({
    validateSearch: (search) => podV2SearchSchema.parse(search),
    component: PodV2Route,
    pendingComponent: PodV2PendingPage,
    pendingMs: 0,
    pendingMinMs: 0,
});

function PodV2Route() {
    const search = Route.useSearch();

    return (
        <PodV2Page
            publishGrpId={search.publishGrpId}
            publishId={search.publishId}
            returnTo={search.returnTo}
        />
    );
}
